import React, { useState } from "react";
import Button from "../../../components/form/Button";
import ProductAction from "./ProductAction";

import { classNames } from "../../../helpers/classNames";
import MediaImage from "../../../components/elements/MediaImage";

const MediaCard = ({
  data,
  actions,
  selectable,
  isSelected,
  onSelectChange,
}) => {
  const [imageLoading, setImageLoading] = useState(true);

  return (
    <div className="relative rounded border w-full h-full flex flex-col overflow-hidden hover:shadow-lg transition duration-300">
      {selectable && (
        <div className="absolute top-2 left-2 z-10 bg-white p-1 rounded">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={() => onSelectChange(data)}
          />
        </div>
      )}
      <div className="rounded border w-full h-full flex flex-col overflow-hidden hover:shadow-[0_5px_10px_0px_rgb(0,0,0,0.3)] hover:scale-110 transition duration-300">
        <div className="relative 2xl:pl-12 xl:pl-8 xl:pr-16 md:pl-4 md:pr-4 pl-3 pr-3 md:pt-6 pt-3 pb-2">
          <div className="relative w-full pb-[130%] overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full">
              <MediaImage
                classes="w-full h-full object-cover"
                src={data?.url}
                alt="Media Image"
                effect="blur"
                imageLoading={imageLoading}
                setImageLoading={setImageLoading}
              />
            </div>
          </div>

          <div className="absolute top-1/2 -translate-y-2/4 right-0 space-y-2 xl:bg-transparent bg-white xl:shadow-none shadow-[0_5px_10px_0px_rgb(0,0,0,0.3)] rounded-lg">
            {/* <div className="xl:pr-3 md:p-2 p-1 mt-0 !pb-0">
            <Button
              buttonClasses={classNames(
                "!p-2 !w-10 !h-10 !justify-center !bg-transparent md:!px-2 !px-1 font-medium !text-black hover:!text-slate-100 hover:!bg-slate-900 !rounded-full md:h-10 h-8 flex items-center justify-center transition-all duration-200 !text-xl"
              )}
              buttonLabelClasses=""
              buttonIcon="fa-light fa-heart"
              buttonIconPosition="left"
              buttonHasLink={false}
              buttonFunction={() => {}}
            />
          </div> */}

            <ProductAction data={data} actions={actions} />
          </div>
        </div>

        <div className="xl:px-4 px-1 xl:pb-4 xl:pt-3 pb-2 pt-2 text-center mt-auto">
          <h2 className="inline-block xl:px-0 px-0 py-1 xl:text-lg md:text-base text-sm font-bold text-gray-700 xl:mr-0 mr-0 truncate">
            {data?.name || "Untitled"}
          </h2>
        </div>
      </div>
    </div>
  );
};

export default MediaCard;
